// src/composables/useSerials.js
import { ref } from 'vue';
import apiClient from '@/api/client';
import { SecureStorage } from '@/utils/secureStorage';

// IMPORTANTE: Asegúrate de que diga "export function"
export function useSerials() {
  const isLoadingSerial = ref(false);

  const SERIAL_TYPES = {
    BRANCH: 1,
    CUSTOMER: 2,
    PRODUCT: 3,
    LOAN: 4
  };

  const generateCode = async (typeKey, context = {}) => {
    isLoadingSerial.value = true;
    const companyId = SecureStorage.getItem('llevo_user')?.company;
    const type = SERIAL_TYPES[typeKey];
    const branchId = SecureStorage.getItem('llevo_user')?.branch;
    const productId = context.productId || 0;

    try {
      // Usamos el endpoint en plural 'serials' para clientes/préstamos
      const response = await apiClient.post('/serials/reserve_next', {
          type: type,
          company: companyId,
          branch: branchId
      });

      const current = response.data.current;

      const co = String(companyId).padStart(2, '0');
      const br = String(branchId).padStart(2, '0');
      const pr = String(productId).padStart(2, '0');
      const seq = String(current).padStart(10, '0');

      switch (typeKey) {
        case 'BRANCH': return String(current).padStart(2, '0');
        case 'CUSTOMER': return `${co}${br}${seq}`;
        case 'PRODUCT': return String(current).padStart(2, '0');
        case 'LOAN': return `${co}${br}${pr}${seq}`;
        default: throw new Error("Tipo inválido");
      }
    } catch (error) {
      console.error("Error en serials:", error);
      throw error;
    } finally {
      isLoadingSerial.value = false;
    }
  };

  return {
    generateCode,
    isLoadingSerial,
    SERIAL_TYPES
  };
}